import api from './axios';
import { MarketParams } from '../types';

export const getMarketParams = () =>
  api.get<MarketParams>('/market-params').then(r => r.data);

export const updateMarketParams = (data: Partial<MarketParams>) =>
  api.put<MarketParams>('/market-params', data).then(r => r.data);
